// extracted by mini-css-extract-plugin
export var headerCell = "_6o-1";
export var loadingSpinnerContainer = "_6o-4";
export var loadingStateCell = "_6o-5";
export var rowWrapper = "_6o-3";
export var standaloneTable = "_6o-6";
export var table = "_6o-0";
export var white = "_6o-2";